import { createTranslationRef } from '@backstage/core-plugin-api/alpha';
import enMessages from './translations/en.json';

export const ciandtspikeDeleteEntityTranslationRef = createTranslationRef({
  id: 'plugin.ciandtspike-delete-entity',
  messages: enMessages,
});
